import { useEffect } from 'react'
import ScrollReveal from '@/components/marketing/ScrollReveal'
import { track } from '@/lib/analytics'
import type { PaymentCompleteProps } from '@/types/apply'

export default function PaymentComplete(props: PaymentCompleteProps) {
  useEffect(() => {
    track('payment_success', {
      metaEvent: 'Purchase',
      conversion: 'payment_success',
      data: {
        application_token: props.token,
        // value = first month's subscription cost (recurring revenue is tracked
        // server-side per charge via the GA4 purchase ping).
        value: props.value ?? undefined,
        currency: props.currency ?? undefined,
      },
    })
  }, [props.token])

  return (
    <section className="marketing-hero-section">
      <div className="container mx-auto px-6 py-20">
        <ScrollReveal direction="up">
          <div className="mx-auto max-w-lg text-center">
            <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-green-500/10">
              <svg className="h-10 w-10 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className="marketing-display text-3xl">Application Submitted!</h1>
            <p className="marketing-lead mt-4">
              Your application has been received successfully. Our team will review it and get back to you within 24-48 hours.
            </p>
            <div className="mt-6 rounded-xl border border-white/10 bg-white/[0.04] px-6 py-4">
              <p className="text-sm text-white/50">Your application token</p>
              <p className="mt-1 font-mono text-lg text-[#ff6a1a]">{props.token}</p>
              <p className="mt-2 text-xs text-white/30">Save this token to check your application status</p>
            </div>
            <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
              <a href="/" className="marketing-button-secondary">Back to Home</a>
              <a href={`/status/${props.token}`} className="marketing-button-primary">Check Status</a>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  )
}
